import { render, staticRenderFns } from "./DocumentMiniMap.vue?vue&type=template&id=6d4fb103"
import script from "./DocumentMiniMap.vue?vue&type=script&lang=js"
export * from "./DocumentMiniMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports